/**登陆**/
<template>
  <div class="login">
    <div class="loginContent">
      <div class="cancle" @click="cancleFn">
        <img src="../../assets/img/login/close.png" alt="取消">
      </div>
      <div class="title">登录</div>
      <!--手机号-->
      <div class="row row1 clear">
        <div class="content">
          <span class="phone">
            <span class="icon"><img src="../../assets/img/login/phone.png" alt="电话号码"/></span>
            <input placeholder="手机号" v-model="phoneNo"
                   type="tel" :maxlength="phoneLength" @input="loginStateFn(1)"/>
          </span>
        </div>
      </div>
      <!--图形验证码-->
      <div class="row row3 clear" v-if="step===1">
        <div class="top clear">
          <span class="icon"><img src="../../assets/img/login/piccode.png" alt="图形验证码"></span>
          <span class="imgCode">
            <input placeholder="图形验证码" :maxlength="4" v-model="imgCode" @input="loginStateFn(2)"/>
          </span>
          <span class="img" @click="getImgCodeFn">
            <xk-img-code :code="imgCodeUrl"></xk-img-code>
          </span>
        </div>
      </div>
      <!--短信验证码-->
      <div class="row row2 clear" v-if="step===2">
        <div class="sms">
          <span class="icon"><img src="../../assets/img/login/sms.png" alt="短信验证码"></span>
          <span class="numCode">
            <input placeholder="短信验证码" v-model="smsCode" type="tel" maxlength="4" @input="loginStateFn(3)"/>
          </span>
          <span class="numCodeBut" :class="phoneCodeText==='获取短信验证码'?'numCodeButShow':''" @click="getSmsCodeFn">
            {{ phoneCodeText }}
          </span>
        </div>
      </div>
      <!--忘记密码-->
      <div class="row row5 clear" v-if="step===4">
        <div class="icon-input">
          <span class="icon"><img src="../../assets/img/login/password.png" alt="重置密码"></span>
          <span class="password">
          <input placeholder="重置密码" v-model="password" type="password" maxlength="10"
                 @input="loginStateFn(4)"/>
        </span>
        </div>
      </div>
      <!--设置密码-->
      <div class="row row5 clear" v-if="step===5">
        <div class="icon-input">
          <span class="icon"><img src="../../assets/img/login/password.png" alt="重置密码"></span>
          <span class="password">
          <input placeholder="设置6-10位密码" v-model="password" type="password" maxlength="10"
                 @input="loginStateFn(5)"/>
        </span>
        </div>
      </div>
      <!--登陆密码-->
      <div class="row row5 clear" v-if="step===3" style="height:auto;">
        <div class="icon-input">
          <span class="icon"><img src="../../assets/img/login/password.png" alt="重置密码"></span>
          <span class="password">
            <input placeholder="登录密码" v-model="password" type="password"
                   @input="loginStateFn(4)" maxlength="10"/>
          </span>
        </div>
        <div class="textBtn" style="width: 100%;display: flex;justify-content: space-between">
          <div class="forget" @click="forgetFn">
            忘记密码
          </div>
          <div class="nextStep" @click="nextStep">
            下一步
          </div>
        </div>
      </div>
      <!--登陆密码，老用户，有密码，关双因子-->
      <div class="row row5 clear" v-if="step===6" style="height:auto;">
        <div class="icon-input">
          <span class="icon"><img src="../../assets/img/login/password.png" alt="重置密码"></span>
          <span class="password">
            <input placeholder="登录密码" v-model="password" type="password"
                   @input="loginStateFn(6)" maxlength="10"/>
          </span>
        </div>
        <div class="textBtn" style="width: 100%;display: flex;justify-content: space-between">
          <div class="forget" @click="forgetFn">
            忘记密码
          </div>
        </div>
      </div>
      <!--登录按钮-->
      <div class="loginBut" :class="loginState && agree ? 'loginButShow' : ''" @click="loginButFn">
        {{ forgetState ? '确认' : '登录' }}
      </div>
      <!--用户协议-->
      <div class="row row4">
        <img src="../../assets/img/login/checked.png" alt="已同意" v-if="agree" @click="changeToUnAgreeFn">
        <img src="../../assets/img/login/uncheck.png" alt="未同意" v-if="!agree" @click="changeToAgreenFn">
        <p>已阅读并已同意<span class="protocol" @click="userxieyiFn">《用户协议》</span></p>
      </div>
    </div>
    <xk-alert-box :text="alertText" v-if="alertText"></xk-alert-box>
    <xk-hint-box :state="hintBox.state" :content="hintBox.content" v-if="hintBox.stateShow"></xk-hint-box>


    <div v-if="visible">
      <slideVerify :loading="loading" ref="slideVerify" :phone="phoneNo" @dragEnd="getSmsCodeFn"
                   :visible.sync="visible"></slideVerify>
    </div>

  </div>
</template>

<script>
import Toucth from '../../assets/js/method'
import {mapGetters} from 'vuex'
import XkAlertBox from '../module/alertBox/src/alertBox'
import XkHintBox from '../module/hintBox/src/hintBox'
import cookieJS from 'js-cookie'
import slideVerify from './components/slideVerify.vue'


export default {
  components: {
    XkHintBox,
    XkAlertBox,
    slideVerify
  },
  data() {
    return {
      forgetState: false,
      phoneLength: '11', // 电话输入框长度
      phoneRegion: '中国 +86', // 区号
      phoneRegionUl: false, // 区号选择
      phoneNo: '', // 电话
      phoneAes: null, // 加密电话
      smsCode: '', // 数字验证码
      imgCode: '', // 图形验证码
      password: '', // 登录密码
      imgCodeUrl: null, // 图形验证码链接
      loginState: false, // 登陆按钮
      alertText: '', // 提示信息
      hintBox: {
        stateShow: false,
        state: 'yes',
        content: ''
      },
      time: '',
      country: '中国', // 国家
      phoneCodeText: '获取短信验证码', // 短信验证码 按钮 文本
      imgCodeState: false, // 图形验证码是否正确
      newUserState: false, // 是否是新号
      step: null, // 1 图片验证码  2 短信验证码
      factor: null, // 双因子
      hasPassword: true, // 老用户是否有密码
      showSmsInput: true,
      agree: true, // 同意用户协议
      visible: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      positioning: 'positioning',
      companyInfo: 'companyInfo',
      infoData: 'infoData',
      login: 'login',
      loginData: 'loginData'
    }),
    imgUrlFn: function () {
      this.$store.dispatch('validateState', {state: true, text: '获取验证码'})
    },
    numCodeButStateFn: function () {
      if (Toucth.checkPhone(this.phoneNo)) {
        return true
      }
      return false
    }
  },
  watch: {
    login(val) { // 监听是否登录
      if (val) { // 登录状态
        let appKey = cookieJS.get('cookieAppKey') ? cookieJS.get('cookieAppKey') : window.configure.appKey
        this.$router.push({path: '/daijia', query: {app_key: appKey}})
      }
    }
  },
  mounted() {
    if (this.$route.query.tel) {
      this.phoneNo = this.$route.query.tel
      this.loginStateFn(1)
    }

    // this.getImgCodeFn()
  },
  methods: {
    loginButFn: function () { // 登陆按钮
      if (!this.loginState) {
        return
      }
      if (this.newUserState || this.forgetState) {  // 新号 设置密码
        this.postRegisterFn()
      } else { // 老号 密码登录
        if (this.hasPassword) {
          this.postEmployLoginFn()
        } else {
          if (this.factor === 1) {
            this.postRegisterFn()
          } else {
            this.postEmployLoginFn()
          }
        }
      }
    },
    postEmployLoginFn() { // 密码登录
      let that = this
      let pw = null
      if (that.password) {
        pw = that.$utils.aesEncryptCode(that.password)
      }
      that.$store.dispatch('postLogin', {
        phone: that.phoneAes,
        country: that.country,
        open_id: window.configure.open_id,
        password: pw,
        fn(state, code) {
          console.log(state, code)
          that.loginState = false
          if (code === 20051 || code === 20048) {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '密码错误'
            }
            setTimeout(() => {
              that.hintBox.stateShow = false
              return false
            }, 1500)
            return false
          }
          that.phoneNo = ''
          that.password = ''
          that.imgCode = ''
          that.smsCode = ''
          that.step = null
          that.$router.push('/')
        }
      })
    },
    RegionButFn: function (val) { // 切换区号
      let that = this
      if (typeof val === 'string') {
        that.phoneRegion = val
      }
      that.phoneRegionUl = !that.phoneRegionUl
    },
    getSmsCodeFn: function (row) { // 获取 短信验证码
      let that = this
      if (that.phoneCodeText !== '获取短信验证码') {
        that.hintBox = {
          stateShow: true,
          state: 'no',
          content: '您登陆过于频繁，请两分钟后再登陆'
        }
        setTimeout(function () {
          that.hintBox.stateShow = false
        }, 10000)
        that.showSmsInput = false
        return
      }
      that.showSmsInput = true
      console.log(that.companyInfo);
      that.$store.dispatch('getSmsCode', {
        country: that.country,
        phone: that.phoneAes,
        company_id:that.companyInfo.id,
        ...row,
        fn(data) {
          if (data && data.code === 1) {
            that.phoneCodeTextFn(120)
            that.visible = false
          }else if (data.code === 121199) {
            that.visible = true
          } else if (data.code === 121205 || data.code === 121203) {
            that.$refs.slideVerify.initPic()
          } else if (data.code === 121209) {
            that.visible = false
          } else {
            that.$refs.slideVerify.initValue()
          }
          const msgCode = {
            121200: '您操作的太快啦,请重试',
            121201: '您操作的太慢啦,请重试',
            121202: '验证错误,请重试',
            121209: '短信验证码获取频繁，请稍后重试',
            121205:"已过期,请重试",
            121203:"已过期,请重试",
          }
          if(msgCode[data.code]){
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: msgCode[data.code]
            }
            setTimeout(() => {
              that.hintBox.stateShow = false
              return false
            }, 1000)
          }
        }
      })
    },
    phoneCodeTextFn(num) { // 手机验证码 按钮文字 num 剩余时间
      let that = this
      let countFn = () => { // 计算倒计时
        num--
        if (num <= 0) {
          that.phoneCodeText = '获取短信验证码'
        } else {
          that.phoneCodeText = num + 's'
          setTimeout(() => {
            countFn(num)
          }, 1000)
        }
      }
      countFn(num)
    },
    postCheckCodeFn(code, codeType) { // 检验验证码是否正确 code 码  codeType 码的类型  sms 短信 pic 图形
      let that = this
      that.$store.dispatch('postCheckCode', {
        country: that.country,
        phone: that.phoneAes,
        code: code,
        code_type: codeType,
        fn(data) {
          if (data && data.code === 1) {
            // if (codeType === 'pic' && that.newUserState) { // 判断是不是  图形验证码 如果是新号  验证手机验证码
            //   that.imgCodeState = true
            //   that.step = 2
            //   that.getSmsCodeFn()
            // } else if (that.forgetState) {
            //   that.password = null
            //   that.step = 4
            // } else { // 不是新号 则输密码
            //   that.step = 3
            // }
            if (codeType === 'pic') { // 图形验证码
              that.imgCodeState = true
              that.getSmsCodeFn()
              if (that.showSmsInput) {
                that.step = 2
              }
            }
            if (codeType === 'sms') { // 短信验证
              if (that.newUserState) { // 新用户
                // if (that.factor === 1 || that.forgetState) { // 开启双因子
                //   that.step = 5
                // } else {
                //   that.loginState = true
                // }
                that.loginState = true
              }
              if (!that.newUserState) { // 老用户
                if (that.hasPassword) {
                  that.loginState = true
                }
                if (!that.hasPassword) {
                  if (that.factor === 1 || that.forgetState) {
                    that.step = 5
                  } else {
                    that.loginState = true
                  }
                }
              }
            }
          } else {
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '验证码错误'
            }
            setTimeout(function () {
              that.hintBox.stateShow = false
            }, 1000)
          }
        }
      })
    },
    getCheckUserFn() { // 检查 手机 是否存在
      let that = this
      that.$store.dispatch('getCheckUser', { // step:1 图形验证码 2 短信验证码 3 忘记密码/登陆密码 4 设置密码
        phone: that.phoneAes,
        country: that.country,
        fn(data) {
          if (data.code === 50013 || data.code === 50014) { // 老用户
            that.newUserState = false
            if (data.msg.indexOf('has password') !== -1) { // 有密码
              that.hasPassword = true
              if (data.factor === 1) {
                that.step = 3
              } else {
                that.step = 6
              }
            } else {
              that.hasPassword = false
              that.step = 2
              // that.getImgCodeFn()
            }
          } else if (data.code === 30044) { // 新用户
            that.step = 2
            // that.getImgCodeFn()
            that.newUserState = true
          }
          that.factor = data.factor
        }
      })
    },
    postRegisterFn() { // 注册
      let that = this
      let pw = null
      let appKey = cookieJS.get('cookieAppKey') ? cookieJS.get('cookieAppKey') : window.configure.appKey
      if (that.password && that.password !== '') {
        pw = that.$utils.aesEncryptCode(that.password)
      }
      that.$store.dispatch('postRegister', {
        password: pw, // 密码
        phone: that.phoneAes, // 电话
        channel: 'wechat', // 渠道
        country: that.country, // 国家
        open_id: window.configure.open_id,
        fn(data) {
          if (data && data.code === 1) {
            that.forgetState = false
            that.loginState = false
            that.step = null
            that.phoneNo = ''
            that.password = ''
            that.imgCode = ''
            that.smsCode = ''
            that.$router.push({path: '/daijia', query: {app_key: appKey}})
          } else {
            console.log("111111111");
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: data.msg
            }
            setTimeout(() => {
              that.hintBox.stateShow = false
              return false
            }, 1000)
          }
        }
      })
    },
    forgetFn() {
      this.forgetState = true
      this.step = 1
      this.getImgCodeFn()
      this.newUserState = true
    },
    loginStateFn: function (num) {  // 登录检测 1 电话 2 图形验证码 3 短信验证码 4 设置/重置/输入密码 5 设置密码 6 登陆，关双因子
      let that = this
      switch (num) {
        case 1:
          if (that.$utils.checkPhone(that.phoneNo)) { // 电话号码是否正确
            that.phoneAes = that.$utils.aesEncryptCode(that.phoneNo)
            that.getCheckUserFn()
          } else {
            that.step = null
          }
          break
        case 2:
          if (that.imgCodeUrl === that.imgCode) { // 图形验证码是否正确
            that.postCheckCodeFn(that.$utils.aesEncryptCode(that.imgCode), 'pic')
          } else {
            that.imgCodeState = false
          }
          break
        case 3:
          if (that.smsCode.length === 4) { // 短信验证码是否正确
            that.postCheckCodeFn(that.$utils.aesEncryptCode(that.smsCode), 'sms')
          } else {
            that.imgCodeState = false
          }
          break
        case 4:
          // if (that.password.length >= 6) { // 密码是否正确
          //   if (that.newUserState) {
          //     that.loginState = true
          //   }
          //   if (!that.newUserState) {
          //     if (that.hasPassword) {
          //       if (that.factor === 1) {
          //         that.step = 1
          //         // 需要发送图形验证码
          //         that.getImgCodeFn()
          //       } else {
          //         that.loginState = true
          //       }
          //     }
          //     if (!that.hasPassword) {
          //       that.loginState = true
          //     }
          //   }
          // } else {
          //   that.loginState = false
          // }
          // if (that.password.length >= 6) {
          //   if (!that.newUserState && that.hasPassword && that.factor === 1) {
          //     that.loginState = false
          //   } else {
          //     that.loginState = true
          //   }
          // } else {
          //   that.loginState = false
          // }
          break
        case 5:
          if (that.password.length >= 6) {
            that.loginState = true
          } else {
            that.loginState = false
          }
          break
        case 6:
          if (that.password.length >= 6) {
            that.loginState = true
          } else {
            that.loginState = false
          }
          break
      }
    },
    nextStep() {
      let that = this
      if (that.password.length >= 6) { // 密码是否正确
        if (that.newUserState) {
          that.loginState = true
        }
        if (!that.newUserState) {
          if (that.hasPassword) {
            if (that.factor === 1) {
              that.step = 1
              // 需要发送图形验证码
              that.getImgCodeFn()
            } else {
              that.loginState = true
            }
          }
          if (!that.hasPassword) {
            that.loginState = true
          }
        }
      } else {
        that.loginState = false
      }
    },
    userxieyiFn: function () { // 跳转 用户协议
      this.$store.dispatch('loginAction', {state: true})
      this.$router.push('/serviceAgreement')
    },
    getImgCodeFn() { // 获取 切换 图片
      let that = this
      that.imgCode = null
      this.$store.dispatch('getImgCode', {
        phone: that.$utils.aesEncryptCode(that.phoneNo),
        country: that.country,
        fn(data) {
          if (data && data.code === 1) {
            // that.imgCodeUrl = data.data
            that.imgCodeUrl = that.$utils.aesDecryptCode(data.data)
          }
        }
      })
    },
    cancleFn() {
      this.$router.go(-1)
    },
    changeToUnAgreeFn() { // 未同意服务协议
      this.agree = false
    },
    changeToAgreenFn() { // 已同意服务协议
      this.agree = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
.login {
  width: 100%;
  height: 100vh;
  background-color: #ffffff;

  .forget {
    color: #f06553;
    font-size: 0.8333rem;
    display: inline-block;
  }

  .nextStep {
    font-size: 0.8333rem;
    display: inline-block;
  }

  .loginContent {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    z-index: 777;

    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      color: rgba(0, 0, 0, 1);
      margin-left: 12px;
      margin-bottom: 36px;
      padding-top: 31px;
    }

    .cancle {
      position: fixed;
      right: 32px;
      top: 32px;
      z-index: 10;
    }

    .row {
      width: 100%;
      box-sizing: border-box;
      height: 2.9166rem;
      line-height: 2.9166rem;
      padding: 0 1rem;
      margin: 1rem 0;
    }

    .row1 {
      .content {
        width: 100%;
        height: 100%;
        border-bottom: 1px solid #eee;
      }

      .Region {
        float: left;
        height: 100%;
        position: relative;
        width: 5.8333rem;
        text-align: center;

        ul {
          position: absolute;
          left: 0;
          top: 3rem;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
          border-radius: 0.333rem;
          background-color: #fff;
          width: 100%;
          z-index: -100;
          font-size: 1rem;
          color: #2c2c2c;
          transform-origin: 0 0;
          opacity: 0;

          li {
            width: 100%;
          }
        }

        .showUl {
          z-index: 10;
          opacity: 1;
        }
      }

      .Region:after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 1px;
        height: 50%;
        background-color: #eee;
      }

      .phone {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        height: 100%;
        width: 100%;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 10%;
          height: 100%;
        }

        input {
          box-sizing: border-box;
          width: 90%;
          border: none;
          padding: 0 0.5rem;
          height: 100%;
          font-size: 1rem;
          color: #2c2c2c;
        }
      }

    }

    .row2 {
      padding: 0 1em;

      .sms {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 10%;
          height: 100%;
        }

        .numCode {
          height: 100%;
          width: 55%;
          float: left;
          box-sizing: border-box;
          overflow: hidden;

          input {
            font-size: 1rem;
            box-sizing: border-box;
            height: 100%;
            width: 100%;
            border: none;
            color: #2c2c2c;
            padding: 0 0.5rem;
          }
        }

        .numCodeBut {
          box-sizing: border-box;
          width: 35%;
          font-size: 0.8333rem;
          float: left;
          height: 80%;
          background-color: #f4f4f4;
          border-radius: 0.333rem;
          overflow: hidden;
          margin-left: 1rem;
          color: #999;
          transition: 0.3s all;
          text-align: center;
          border: 1px solid #eee;
        }

        .numCodeButShow {
          color: #fff;
          background: #f06553;
        }
      }
    }

    .row3 {
      height: auto;
      line-height: inherit;

      .top {
        display: flex;
        justify-content: space-between;
        height: 2.9166rem;
        border-bottom: 1px solid #eee;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 10%;
          height: 100%;
        }

        .imgCode {
          float: left;
          height: 100%;
          width: calc(~'100% - 7.25rem');

          input {
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            border: none;
            font-size: 1rem;
            padding: 0 0.5rem;
            color: #2c2c2c;
          }
        }

        .img {
          float: left;
          box-sizing: border-box;
          width: 25%;
          font-size: 0.8333rem;
          height: 80%;
          background-color: #f4f4f4;
          border-radius: 0.333rem;
          overflow: hidden;
          margin-left: 1rem;
          color: #333333;
          text-align: center;
          border: 1px solid #eee;

          img {
            width: 80%;
            height: 80%;
          }
        }

      }

      .bottom {
        width: 100%;
        text-align: center;
        font-size: 0.8333rem;
        margin-top: 0.3rem;
        color: #999999;
      }
    }

    .row5 {
      .icon-input {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 10%;
          height: 100%;
        }

        .password {
          height: 100%;
          width: 100%;
          float: left;
          box-sizing: border-box;
          border-radius: 0.333rem;
          overflow: hidden;

          input {
            font-size: 1rem;
            box-sizing: border-box;
            height: 100%;
            width: 100%;
            border: none;
            color: #2c2c2c;
            padding: 0 0.5rem;
          }
        }
      }
    }

    .row4 {
      display: flex;
      justify-content: start;
      line-height: inherit;
      height: auto;
      margin-top: 1.6rem;
      font-size: 0.8333rem;
      color: #a5a5a5;

      img {
        margin-top: 3px;
        margin-right: 8px;
        display: inline-block;
        width: 12px;
        height: 12px;
      }

      .protocol {
        color: #f06553;
      }
    }

    .loginBut {
      margin: 36px auto 0;
      width: 95%;
      height: 3.4rem;
      line-height: 3.4rem;
      background-color: #f4f4f4;
      color: #bcbcbc;
      text-align: center;
      font-size: 1.25rem;
      border-radius: 0.333rem;
    }

    .loginButShow {
      background-color: #f06553;
      color: #fff;
    }
  }

  .Module {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 8888;
  }
}

.showLogin {
  z-index: 555;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// login.vue?735bd55a